import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { SensorPasswordUpdateModel } from '../models/sensorEntityModels';

const getUrl = ({ host, gatewayId, deviceId, sensorId }: { host: string; gatewayId: string; deviceId: string; sensorId: string }) => {
  return `${host}/gateways/${gatewayId}/devices/${deviceId}/update-password/${sensorId}`;
};

export const UpdatePasswordSensor = async (sensor: SensorPasswordUpdateModel) => {
  const { host, token, gatewayId, deviceId, sensorId, password } = sensor;

  try {
    const url = getUrl({ host, gatewayId, deviceId, sensorId });

    const options: AxiosRequestConfig = {
      url,
      method: 'POST',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
      data: { data: { password } },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error: any) {
    throw getErrorFormat(error);
  }
};
